// @flow

export const FILE_PREVIEW_LENGTH = 5;
